// @ts-ignore
const path = require('path');

module.exports = {
  i18n: {
    defaultLocale: 'fr',
    locales: ['en', 'fr', 'de'],
  },
  defaultLanguage: 'fr',
  otherLanguages: ['en', 'fr', 'de'],
  localePath: path.resolve('./public/staticfront/locales'),
  serializeConfig: false,
};
